<div *ngIf="loading" class="loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div *ngIf="!loading">
  <div class="error" *ngIf="systemError">
    {{ 'common.systemError' | translate }}
  </div>
</div>